import { render, staticRenderFns } from "./historysuratperingatan.vue?vue&type=template&id=249093a0&scoped=true&"
import script from "./historysuratperingatan.vue?vue&type=script&lang=js&"
export * from "./historysuratperingatan.vue?vue&type=script&lang=js&"
import style0 from "./historysuratperingatan.vue?vue&type=style&index=0&id=249093a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249093a0",
  null
  
)

export default component.exports